<div class="content d-flex flex-column flex-column-fluid">
  <div class="toolbar mb-5">
    <div class="container-fluid d-flex flex-stack">
      <div class="page-title d-flex flex-column align-items-start me-3 mb-5 mb-lg-0">
        <h3 class="d-flex text-dark fw-bolder fs-3 flex-column mb-0" *ngIf="yeni">
          <span><i class="fas fa-plus text-success" style="font-size: large;"></i><span></span> Yeni Talep Ekle</span>
        </h3>
        <h3 class="d-flex text-dark fw-bolder fs-3 flex-column mb-0" *ngIf="!yeni">
          <span><i class="fas fa-edit text-success" style="font-size: large;"></i><span></span> Talep Düzenle</span>
        </h3>
      </div>
      <div class="d-flex align-items-center gap-2 gap-lg-3">
        <!-- <a [routerLink]="['yeni']" class="btn btn-sm btn-primary">Yeni Uygulama</a> -->
      </div>
    </div>
  </div>


  <div class="post d-flex flex-column-fluid" id="kt_post">
    <div id="kt_content_container" class="container-fluid">
      <loading [loader]="yukleniyor">
        <form [formGroup]="detayForm" (submit)="upload()" *ngIf="kullaniciTalep!=null; else hata">
          <div class="card col-md-8  offset-md-2 col-12" style="border-top: 4px #77c2e9 solid;">

            <div class="card-header">
              <h3 class="card-title" *ngIf="yeni">
                <span><i class="fas fa-plus text-success" style="font-size: large;"></i><span></span> Yeni Talep
                  Ekle</span>
              </h3>
              <h3 class="card-title" *ngIf="!yeni">

                <span><i class="fas fa-edit text-success" style="font-size: large;"></i><span></span> Talep
                  Düzenle</span>
                <!-- {{ kullaniciTalep.icerik | uppercase}}  Düzenle -->

              </h3>
            </div>
            <div class="card-body ">

              <!-- <div class="d-flex align-items-center bg-light-danger rounded p-3 mb-1">
                <span class="svg-icon svg-icon-warning me-5">
                  <span class="svg-icon svg-icon-1">
                    <i class="far fa-hand-point-right text-danger" style="font-size: larger;"></i>
                  </span>
                </span>
                <div class="flex-grow-1 me-2 fs-4">
                  <h3><i class="fas fa-exclamation-triangle me-2 text-danger"></i> ÖNEMLİ ( 7417 Sayılı Kanun ile
                    Düzenlenen Öğrenci Affı Hakkında )</h3>
                  Öğrenci Affından yararlanmak isteyen kişilerin Talep Kategorisi kısmından <b>"AF (Öğrenci Affı
                    Başvurusu)"</b> seçeneğini seçmesi ve istenilen belgeleri sıkıştırılmış tek dosya şeklinde (.zip,
                  .rar, .7zip uzantılı) <b>"Dosya Ekle"</b> kısmından eksiksiz bir şekilde eklemesi gerekmektedir.
                  <b>Talep Açıklaması</b> kısmına af başvurusu ile ilgili bilgiler girilmelidir. İstenilen belgeler ile
                  ilgili detaylı bilgiye <a href="https://www.erbakan.edu.tr/" target="_blank"> Neü web sitesinden </a>
                  ulaşılabilir.
                  <span class="text-muted fw-bold d-block"></span>
                </div>
                <span class="fw-bolder text-warning py-1"></span>
              </div> -->



              <div class="d-flex align-items-center bg-light-warning rounded p-3 mb-1">
                <!--begin::Icon-->
                <span class="svg-icon svg-icon-warning me-5">
                  <!--begin::Svg Icon | path: icons/duotune/abstract/abs027.svg-->
                  <span class="svg-icon svg-icon-1">
                    <i class="far fa-hand-point-right text-danger" style="font-size: larger;"></i>
                  </span>
                  <!--end::Svg Icon-->
                </span>
                <!--end::Icon-->
                <!--begin::Title-->
                <div class="flex-grow-1 me-2 fs-6">
                  Taleplerinizin sonucunu Sms olarak bildirim almak istiyorsanız, <b>"Talep sonuçlandığında SMS ile
                    bilgilendir"</b> seçeneğini seçmeniz gerekmektedir.
                  <span class="text-muted fw-bold d-block"></span>
                </div>

                <!--end::Title-->
                <!--begin::Lable-->
                <span class="fw-bolder text-warning py-1"></span>
                <!--end::Lable-->
              </div>
              <!-- <div class="form-group ">
                <label class="col-lg-3 col-form-label text-right fs-6 text-info">Talepte Bulunan Kişi : </label>
                <div class="col-lg-9">
                  <label class="col-form-label text-right fs-6 text-dark"> {{ kisiAdSoyad }}</label>
                </div>
              </div>
              <br> -->
              <br>
              <div class="form-group row">
                <label class="col-lg-3 col-form-label text-right fs-6 text-info">Talep Kategorisi : <span
                    class="text-danger"> *
                  </span></label>
                <div class="col-lg-9">
                  <select class="form-control" name="kategoriId" id="kategoriId" formControlName="kategoriId"
                    style="border-color: #8fb9d5;">
                    <option [ngValue]=0>Seçiniz</option>
                    <option *ngFor="let kategori of talepKategoriler" [ngValue]="kategori.id">{{kategori.kategoriAdi}}
                    </option>
                  </select>
                  <div class="text-danger fs-5 fw-bold" *ngFor="let hata of hatalar['KategoriId']">
                    {{hata}}
                  </div>
                </div>
              </div>
              <br>
              <div class="form-group row" >
                <label class="col-lg-3 col-form-label text-right fs-6 text-info">Sorumlu Birim : <span
                    class="text-danger"> *
                  </span></label>
                <div class="col-lg-9">
                  <select class="form-control"  style="border-color: #8fb9d5;" name="birimId" id="birimId" (change)="secBirimkontrol()" [(ngModel)]="secilenBirimId"
                    formControlName="birimId">
                    <option [ngValue]=0>Seçiniz</option>
                    <option *ngFor="let birim of talepBirimler" [ngValue]="birim.id">{{ birim.birimAdi }}</option>
                  </select>
                  <div class="text-danger fs-5 fw-bold" *ngFor="let hata of hatalar['BirimId']">
                    {{hata}}
                  </div>
                </div>
              </div>
              <br>
              <div class="form-group row" *ngIf="secilenBirimId==31">
                <label class="col-lg-3 col-form-label text-right fs-6 text-info">Devam etmek için yan taraftaki kutucuklardan birini işaretleyiniz. <span
                  class="text-danger"> *
                </span></label>
                <div class="col-lg-9">
                  <span>
                                    <input type="radio" class="form-check-input me-3"  id="ogrSifreBilgi"
                    name="ogrSifreBilgi"  (change)="rdkontrol()"  [(ngModel)]="ogrSifreTalep"  [ngModelOptions]="{standalone: true}"  [value]="true">
                  <span class="form-check-label checkbox-lg text-black text-justify" style="font-size:medium;" style="font-size:medium; color: darkblue;" for="exampleCheck1">
                    Öğrenci e-posta adresimi öğrenmek, e-posta hesabıma giriş yapmak veya Office 365 lisans şifremi öğrenmek istiyorum. </span>
                  </span>
  
                    <br>
                    <br>
                    <input type="radio"  class="form-check-input me-3"  id="ogrSifreBilgi"  [(ngModel)]="ogrSifreTalep" (change)="rdkontrol()" [ngModelOptions]="{standalone: true}"  
                    name="ogrSifreBilgi">
                  <span class="checkbox-lg  text-justify" style="font-size:medium; color: darkblue;" for="exampleCheck1">
                   Başka bir talep ileteceğim. </span>
                </div>
              </div>              
              <br>
              <div class="form-group row"  *ngIf="!aciklamaKapat">
                <label class="col-lg-3 col-form-label text-right fs-6 text-info">Talep Açıklaması : <i
                    class="far fa-question-circle"
                    title="Talebiniz ile ilgili ayrıntılı bilgiyi giriniz. Bağlı olduğunuz Fakülte/ Enstitü / Yüksekokul/ Meslek Yüksek Okulu - Bölüm - Program bilgilerini belirtiniz ve Sorumlu Birim seçeneğini bağlı olduğunuz birime göre yapınız.  Eğer belge istiyorsanız belgenizle ilgili detayları ( İlgili Fakülte/ Enstitü / Yüksekokul/ Meslek Yüksek Okulu - Bölüm - Program bilgileri, belge tipi, zaman vs. ) kesinlikle belirtiniz ( Örnek : 1998 yılında Neü Mühendislik Fakültesi / Bilgisayar Mühendisliği Bölümün' den mezun oldum. Transkript belgemin düzenlenerek sistem üzerinden verilmesini rica ederim. ). "
                    style="font-size: x-large;color: #77C2E9;"></i> <span class="text-danger"> *
                  </span></label>
                <div class="col-lg-9">
                  <textarea style="border-color: #8fb9d5;" class="form-control" formControlName="icerik"
                    maxlength="1000" rows="10"
                    placeholder="Talebiniz ile ilgili ayrıntılı bilgiyi bu alana giriniz."
                    maxlength="2000"></textarea>
                    <div class="text-danger fs-5 fw-bold" *ngFor="let hata of hatalar['Icerik']">
                      {{hata}}
                    </div>
                  <span class="form-text fs-6" style="color:#17A3C9; text-align:right; "> <i
                      class="fas fa-exclamation-triangle me-2 text-danger"></i>En az 20 karakter olmalıdır. Talebiniz
                    ile ilgili ayrıntılı bilgiyi giriniz. Bağlı olduğunuz Fakülte/ Enstitü / Yüksekokul/ Meslek Yüksek
                    Okulu - Bölüm - Program bilgilerini belirtiniz ve Sorumlu Birim seçeneğini bağlı olduğunuz birime
                    göre yapınız. Eğer belge istiyorsanız belgenizle ilgili detayları ( İlgili Fakülte/ Enstitü /
                    Yüksekokul/ Meslek Yüksek Okulu - Bölüm - Program bilgileri, belge tipi, zaman vs. ) kesinlikle
                    belirtiniz ( Örnek : 1998 yılında Neü Mühendislik Fakültesi / Bilgisayar Mühendisliği Bölümün' den
                    mezun oldum. Transkript belgemin düzenlenerek sistem üzerinden verilmesini rica ederim. ). </span>
                </div>
              </div>
              <br>
              <div class="form-group row" *ngIf="!aciklamaKapat">
                <label class="col-lg-3 col-form-label text-right fs-6 text-info">Dosya Ekle : <span class="text-danger">
                    <br>( Boyutu en fazla 10 MB olan resim, pdf, veya sıkıştırılmış tek dosya (.zip, .rar, .7zip)
                    yüklenebilir.)
                  </span></label>
                <div class="col-lg-5">
                  <div class="form-group">
                    <input type="file" id="file" name="file" (change)="selectFile($event)"
                      accept=".zip,.rar,.7zip,.7z,image/*,.pdf" data-val="true" style="color: #7239EA;" />
                  </div>
                </div>
                <label class="col-lg-4 col-form-label text-left fs-6 text-info" *ngIf="!yeni && this.dyol!=''">Yüklü
                  Dosya : <span style="color: red;">

                    <a class="menu-link">{{ dosyaAd}}</a> </span></label>
              </div>
              <br>
              <div class="form-group row"  *ngIf="!aciklamaKapat">
                <div class="col-lg-3"></div>
                <div class="col-lg-6">
                  <div class="col-lg-12" style="color: black;">
                    <!-- <label
                      class="form-check form-check-custom form-check-solid form-switch mb-5"><input type="checkbox" 
                        formControlName="ePostaSonucBildir" id="ePostaSonucBildir" name="ePostaSonucBildir"
                        class="form-check-input"> <span class="form-check-label fs-6">Talep ile ilgili yapılan işlemleri
                        (talep hareketlerini) E-posta
                        ile bilgilendir. </span>
                      </label> -->
                    <label class="form-check form-check-custom form-check-solid form-switch mb-3">
                      <input type="checkbox" style="border:2px  #77C2E9 solid" formControlName="smsSonucBildir"
                        id="smsSonucBildir" name="smsSonucBildir" class="form-check-input ng-pristine"><span
                        class="form-check-label fs-6">Talep sonuçlandığında
                        SMS ile bilgilendir.</span>
                    </label>
                  </div>

                </div>
              </div>
              <br>

              <div class="form-group row">
                <div class="col-lg-12 " style="text-align: center">
                  <label class="form-check-label text-danger  " style="font-size:medium;" for="exampleCheck1"> (*)
                    Doldurulması zorunlu alanlar.
                  </label>
                </div>
              </div>
              <div class="form-group row" *ngIf="!aciklamaKapat">
                <div class="col-lg-12">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="kvkkCheck" name="kvkkCheck"
                      formControlName="kvkkCheck" value="true">
                    <label class="form-check-label checkbox-lg text-black text-justify" style="font-size:medium;"
                      for="exampleCheck1"> <b><a data-bs-toggle="modal" data-bs-target="#KVKK_modal"
                          style="text-decoration: blink; color:#138496 ">&nbsp;&nbsp;<u>Aydınlatma metnini</u></a>
                        okudum ve onaylıyorum. Ayrıca tarafımca yukarıda vermiş olduğum bilgilerin doğruluğunu ve bu
                        bilgilerin etik dışı olması durumunda doğacak yükümlülüğü kabul ediyorum.</b></label>
                    <br />
                  </div>
                </div>
                <div class="text-danger fs-5 fw-bold" *ngFor="let hata of hatalar['kvkkCheck']">
                  {{hata}}
                </div>
              </div>
            </div>
            <div class="
                                notice
                                d-flex
                                bg-light-warning
                                rounded
                                border-info border 
                                p-6 col-md-10 offset-1 mb-5
                              ">
              <div class="d-flex flex-stack flex-grow-1">
                <div class="fw-bold">
                  <h4 class="fw-bolder" style="color: black;"><i class="fas fa-exclamation-triangle me-1 text-danger"
                      style="font-size: larger;"></i>Her bir talep için ayrı Yeni Talep Kaydı oluşturmanız
                    gerekmektedir. Talep
                    açıklaması kısmına yazacağınız birden fazla talebiniz dikkate alınmayacaktır.</h4>
                </div>
              </div>
            </div>
            <div class="row card-footer  ">
              <div class="col-6 text-left">
                <button type="button" routerLink="/talep-list" id="kt_modal_new_target_cancel"
                  class="btn btn-success btn-hover-rise me-3">
                  <i class="fas fa-list"></i>
                  Talep Listesi</button>
              </div>
              <div class="col-6 text-end"  *ngIf="!aciklamaKapat">
                <submit-button [loader]="kaydediliyor" [label]="yeni?'Kaydet':'Güncelle'"
                  [loading]="yeni?'Kaydediliyor...':'Güncelleniyor...'">
                </submit-button>
              </div>
            </div>
          </div>
        </form>
        <ng-template #hata>
          <span style="color:red">HATA!!!!! TALEP KAYDI BULUNAMADI.</span>
        </ng-template>
      </loading>
    </div>
  </div>




  <div id="KVKK_modal" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <i class="fas fa-file-alt text-danger" style="font-size: large; padding-right:2px;"></i>
          <h2 class="modal-title">KVKK Rıza Metni </h2>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <iframe src="assets/dosyalar/KVKKMetin.pdf" width="2000" height="500" frameborder="0" marginwidth="0"
            marginheight="0" style="border:1px solid #CCC; border-width:1px; margin-bottom:5px; max-width: 100%;"
            allowfullscreen> </iframe>
        </div>
        <div class="modal-footer d-flex justify-content-center">
          <button type="button" class="btn btn-danger" data-bs-dismiss="modal"><i
              class="fas fa-window-close text-info"></i>Kapat</button>
        </div>
      </div>
    </div>
  </div>